import React, { Children } from "react"
import Logo from "../../../images/arden-university.png"
import IconsStyle from "./icons.module.css"

const Icons = ({ children }) => {
  console.log(children.length)
  return(
  <div class={`full-width white ${IconsStyle.iconscontent}`}>
    <div class="page-wrapper">
      {children.length > 0 && 
      <>
        <h1 className={IconsStyle.h1black}>Your questions answered</h1>
        <h3 class={IconsStyle.h3center}>
          Find out everything you need to know about studying with Arden University. We’ll be discussing:
        </h3>
      </>
      }
      {children.slice(0,3)}
      <div style={{ clear: "both" }}></div>
      {children.slice(3,6)}
      <div style={{ clear: "both" }}></div>
      <div style={{ clear: "both" }}></div>
    </div>
  </div>
  )
  }

export default Icons
